export interface CreateContactRequestPayload {
  subject: string;
  description: string;
}

export interface CreateContactRequestResult {
  success: boolean;
  contactRequestId?: string;
  error?: string;
}

export type ContactRequestStatus =
  | 'pending'
  | 'in_review'
  | 'completed'
  | 'cancelled';

/** Statuses from which no further transitions are permitted. */
export const TERMINAL_STATUSES: ReadonlyArray<ContactRequestStatus> = [
  'completed',
  'cancelled',
];

export interface UpdateContactRequestStatusPayload {
  new_status: ContactRequestStatus;
  note?: string;
}

export interface ContactRequestListItem {
  id: string;
  contact_request_id: string;
  subject: string;
  status: ContactRequestStatus;
  assigned_to: string | null;
  created_at: string;
  client_name: string;
  client_user_id: string;
  client_email: string;
  client_phone: string;
  client_profile_url?: string | null;
}

export interface ListContactRequestsResponse {
  data: ContactRequestListItem[];
  pagination: {
    page: number;
    limit: number;
    totalCount: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

export interface ListContactRequestsParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
}
